

export const autoResizeTextarea = (element, maxHeight = 90) => {
    if (element) {
      element.style.height = "auto";
      element.style.height = `${Math.min(element.scrollHeight, maxHeight)}px`;
    }
  };

  export default autoResizeTextarea;
  